
<!-- 删除凭证 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {

				},
				responseCode: {
					"data": {
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台月票管理-删除凭证",
					t_url: this.commonUrls.test + "delMonthTicketCertifiRule",
					p_url: this.commonUrls.prod + "delMonthTicketCertifiRule",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'certifiId',info2: '是',info3: 'Long',info4: '凭证id'},
					 ]
					}
          ],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
              { info1: 'errMsg', info2: '否', info3: 'String', info4: '失败提示' },
						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/delMonthTicketCertifiRule.vue